import { render, staticRenderFns } from "./SettingMenu.vue?vue&type=template&id=f71417b6&"
import script from "./SettingMenu.vue?vue&type=script&lang=ts&"
export * from "./SettingMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports